import { render, staticRenderFns } from "./Goodbye.vue?vue&type=template&id=41916761&scoped=true&"
import script from "./Goodbye.vue?vue&type=script&lang=js&"
export * from "./Goodbye.vue?vue&type=script&lang=js&"
import style0 from "./Goodbye.vue?vue&type=style&index=0&id=41916761&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41916761",
  null
  
)

export default component.exports